// extracted by mini-css-extract-plugin
module.exports = {"UpgradeButton":"upgradeProperty_UpgradeButton__7zrcP","UpgradeContain":"upgradeProperty_UpgradeContain__gkgPP","UpgradeWrapper":"upgradeProperty_UpgradeWrapper__Fqs51"};